import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se encacarga de listar programas
export const listarProgramas = (filtros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/Programas/Listado', filtros).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se encacarga de listar bloques
export const listarBloques = (filtros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/Programas/Bloques/Listado', filtros).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para obtener un Programa por su id
export const obtenerPrograma = (IdPrograma) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.get("/Programas/" + IdPrograma).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// metodo para crear nuevo programa
export const crearPrograma = (programa) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Programas/Crear/", programa).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se encacarga de la actualizacion de un programa
export const actualizarPrograma = (IdPrograma, programa) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.put("/Programas/" + IdPrograma, programa).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para eliminar un programa por su id
export const eliminarPrograma = (programa) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/Programas/Eliminar/", programa).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};




///DETALLES

// Se encacarga de listar detalles programas
export const listarProgramasDetalles = (programa) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/ProgramasDetalles/Listado', programa).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Se usa para eliminar un programa por su id
export const actualizarProgramaDetalle = (programadetalle) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/ProgramasDetalles/Actualizar/", programadetalle).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Se usa para eliminar un programa por su id
export const eliminarProgramaDetalle = (programadetalle) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/ProgramasDetalles/Eliminar/", programadetalle).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};
